import "@src/components/mobileOfficer/mobileOfficer.css";
import "./mobileResponseServices.css";
import { downloadReportPdf } from '@src/util/reportPdf/downloadReportPdf';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Table, Tag, Button, Input, Space, Form, Layout, Calendar, DatePicker, Drawer, Select, Checkbox, Badge, Dropdown, Menu, Divider, Tabs, message, Popover, Pagination, Tooltip } from 'antd';
import { SearchOutlined, FilterOutlined, CloseOutlined, CaretDownFilled, WhatsAppOutlined, PhoneOutlined } from '@ant-design/icons';

import { CustomScheduleModal, NewMobileResponseModal } from "./newMobileResponse.modal.jsx";
import { useLazyQuery, useQuery } from "@apollo/client";
import { getMobileResponseQuery } from "../../util/query/mobileResponse.query.js";
import { getFirstLastDutyBySiteId } from "@src/util/query/schedule.query";
import CronGenerationLogsDrawer from "./cronGenerationLogs.drawer.jsx";
import dayjs from "dayjs";
import isBetween from 'dayjs/plugin/isBetween';
import utc from 'dayjs/plugin/utc';
dayjs.extend(isBetween);
dayjs.extend(utc);
import { Content } from "antd/es/layout/layout.js";
import { EditTaskMainModal } from "./editTaskMainModal";
import { CancelTaskModal } from "./cancelTaskModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAirFreshener, faAnchorLock, faClose, faDollarSign, faEdit, faEllipsisVertical, faEnvelope, faExplosion, faExternalLink, faFileInvoiceDollar, faPhone, faReceipt, faRepeat, faTools, faFileAlt, faBan, faEye, faDownload, faClock, faRightLeft, faBackward, faForward, faCaretLeft, faCaretRight, faArrowsSpin, faFileCirclePlus, faFileImport, faFileExport, faSearch, faClipboardList } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { getSitesQuery } from "@src/util/query/site.query";
import { getPayLevelQuery } from "@src/util/query/paylevel.query";
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import Spinner from "@src/components/spinner";
import { getAgencies } from "@src/util/query/agency.query";
import { GetEmployeeRecord } from "@src/util/query/employee.query";
import { NewETAModal } from "./newEta.modal.jsx";
import {socket} from "@src/config/socket";
import { useSelector } from "react-redux";
import { TransferTask } from "./transferTask.modal.jsx";
import { RouteMapModal } from "@src/components/routeMap/routeMap.modal.jsx";
import Papa from "papaparse";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FloatingHelp } from "@src/components/helpLink/floatingHelp";




const MobileResponseServices = () => {

  const {authenticatedUserDetail} = useSelector(state=>state.userAuthReducer);
  const { Option } = Select;

  const [mobileResponseData, setMobileResponseData] = useState();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [form] = Form.useForm();

  // Modal state
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

  const [dateRange, setDateRange] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [site, setSite] = useState({});



  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [search, setSearch] = useState("");
  const [loading, setLoading]=useState(false);


  const [filters, setFilters] = useState({});

  const [currentViewStatus, setCurrentViewStatus] = useState("");

  // Coords of the record whose "See Route" link was clicked in the Completed tab's
  // Submitted Via column - drives RouteMapModal below.
  const [routeModalCoords, setRouteModalCoords] = useState(null);


  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setSearch(value);
      }, 100),
    []
  );
  

  // Build a UTC-anchored month range from any dayjs object.
  // Extracts local year/month so the resulting UTC timestamps are always
  // midnight on the 1st and 23:59:59.999 on the last day, regardless of timezone.
  const utcMonthRange = (d) => {
    const iso = `${d.year()}-${String(d.month() + 1).padStart(2, '0')}-01`;
    const start = dayjs.utc(iso).startOf('month');
    const end   = dayjs.utc(iso).endOf('month');
    const dates = [];
    for (let day = start; day.isBefore(end) || day.isSame(end, 'day'); day = day.add(1, 'day')) {
      dates.push(day);
    }
    return { start, end, dates };
  };

  const handelDateChange = (date, dateString) => {
    const { start, end, dates } = utcMonthRange(date || dayjs(dateString));
    setStartDate(start);
    setEndDate(end);
    setDateRange(dates);
  };

  const nextMonth = () => {
    const { start, end, dates } = utcMonthRange(dateRange[0].add(1, 'month'));
    setStartDate(start);
    setEndDate(end);
    setDateRange(dates);
  };

  const previousMonth = () => {
    const { start, end, dates } = utcMonthRange(dateRange[0].subtract(1, 'month'));
    setStartDate(start);
    setEndDate(end);
    setDateRange(dates);
  };

  const firstLastDuty = (date) => {
    if (date) {
      const { start, end, dates } = utcMonthRange(dayjs(date, "DD/MM/YYYY"));
      if (startDate?.isSame(start) || endDate?.isSame(end)) return;
      setStartDate(start);
      setEndDate(end);
      setDateRange(dates);
    }
  };

  const disabledDate = (current) => {
    return dateRange.some((date) => date.utc().month() === current.month() && date.utc().year() === current.year());
  };

  // Initialise to current month on mount
  useEffect(() => {
    const { start, end, dates } = utcMonthRange(dayjs());
    setStartDate(start);
    setEndDate(end);
    setDateRange(dates);
  }, []);

// ─── Ref to track modal state inside socket handler ───
const modalVisibleRef = useRef(false);
const [newETAModalVisible, setNewETAModalVisible] = useState(false);
const [newResponseModal, setNewResponseModal] = useState(false);

useEffect(() => {
  modalVisibleRef.current = modalVisible || newETAModalVisible || newResponseModal;
}, [modalVisible, newETAModalVisible, newResponseModal]);

// ─── Ref mirrors currentViewStatus inside socket handler (no stale closure) ─
const currentViewStatusRef = useRef(currentViewStatus);
useEffect(() => {
  currentViewStatusRef.current = currentViewStatus;
}, [currentViewStatus]);

// True only after the server responds with type:'init' — spinner waits for this
const initReceivedRef = useRef(false);
// Mirrors dataSource so the stable useCallback handler can check membership
// for totalCount adjustments without a stale closure.
const dataSourceRef = useRef([]);
// Increments on socket reconnect to re-trigger the subscribe effect
const [subscribeKey, setSubscribeKey] = useState(0);

const [getSites, {data: siteData, loading: siteLoading}] = useLazyQuery(getSitesQuery, {fetchPolicy: 'cache-and-network'});

const debouncedGetSites = useMemo(
  () =>
    debounce((searchTerm) => {
      getSites({
        fetchPolicy: "cache-and-network",
        variables: {
          input: {
            filters: {
              advanceFilter: [
                [{
                  operator: "Site Name",
                  condition: "and",
                  filter: "contain_exactly",
                  filterValue: [searchTerm],
                }],
              ],
            },
            page: 1,
            pageSize: 5,
          },
        },
      });
    }, 300),
  []
);

const {data: firstLastDutyBySite} = useQuery(getFirstLastDutyBySiteId, {
  variables: { siteId: site?._id },
  skip: !site?._id,
  fetchPolicy: 'network-only',
});

// ─── Stable handler — registered once, never re-created ───────────────────
const handleMobileService = useCallback((data) => {
  if (data?.type === 'patch') {
    // Delta patches bypass mobileResponseData entirely and update dataSource
    // directly — one render cycle, one record touched (no O(n) re-sort/re-map).
    const weekdays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
    const toRow = (res, key) => ({
      key,
      jobType: res?.dutyDetail?.name,
      site: res?.siteDetail?.sitename,
      customer: res?.customerDetail?.customername,
      siteDetail: res?.siteDetail?.postcode,
      priority: res?.priority,
      status: res?.status || "onschedule",
      startTime: res?.startTime,
      endTime: res?.endTime,
      reportSubmittedAt: res?.reportSubmittedAt || null,
      submittedVia: res?.submittedVia === "WFC App" ? "WFC App" : "Manually",
      reportSharedAt: res?.reportSharedAt || null,
      reportSharedTo: res?.reportSharedTo || null,
      startAt: res?.startAt || null,
      finishAt: res?.finishAt || null,
      cords: res?.cords || null,
      assignee: res?.employeeDetail
        ? res?.employeeDetail?.firstname + " " + (res?.employeeDetail?.lastname || "")
        : res?.supplierDetail
        ? res?.supplierDetail?.suppliername
        : "---",
      record: res,
      scheduleType: res?.scheduleType === "one-off" ? "One-Off" : "Scheduled",
      scheduleBoxes: weekdays.map(day => ({ day, filled: res?.scheduleDays?.includes(day) })),
    });

    const activeStatus = currentViewStatusRef.current?.toLowerCase() ?? '';
    const isCompleted  = activeStatus === 'completed';

    // Returns true if this record belongs in the currently active tab.
    const matchesTab = (rec) => {
      const s = rec?.status?.toLowerCase() ?? '';
      if (isCompleted)                              return s === 'completed';
      if (activeStatus === 'due')                   return s === 'due' || s === 'overdue';
      // 'all' / '' — everything except cancelled/completed
      return s !== 'cancel' && s !== 'completed';
    };

    const sortRows = (rows) =>
      [...rows].sort((a, b) => {
        const aT = dayjs(a.startTime).isValid() ? dayjs(a.startTime).valueOf() : 0;
        const bT = dayjs(b.startTime).isValid() ? dayjs(b.startTime).valueOf() : 0;
        return isCompleted ? bT - aT : aT - bT;
      });

    if (data.op === 'upsert') {
      const record = data.record;
      const id = record._id?.toString();
      const wasInList = dataSourceRef.current.some(row => row.record?._id?.toString() === id);
      const willBeInList = wasInList
        ? matchesTab(record)   // already there: stays only if still matches tab
        : matchesTab(record);  // new: added only if matches tab
      setDataSource((prev) => {
        const idx = prev.findIndex(row => row.record?._id?.toString() === id);
        if (idx >= 0) {
          // Record already in list — update if changed, remove if no longer in this tab
          if (!matchesTab(record)) return prev.filter((_, i) => i !== idx);
          if (isEqual(prev[idx].record, record)) return prev;
          const next = [...prev];
          next[idx] = toRow(record, prev[idx].key);
          return sortRows(next);
        }
        // New record — only add if it belongs in this tab
        if (!matchesTab(record)) return prev;
        return sortRows([...prev, toRow(record, prev.length)]);
      });
      // Adjust totalCount
      if (!wasInList && willBeInList)  setMobileResponseData(m => m ? { ...m, totalCount: (m.totalCount || 0) + 1 } : m);
      if (wasInList  && !willBeInList) setMobileResponseData(m => m ? { ...m, totalCount: Math.max(0, (m.totalCount || 0) - 1) } : m);
    } else if (data.op === 'delete') {
      const wasInList = dataSourceRef.current.some(row => row.record?._id?.toString() === data.id);
      setDataSource((prev) => prev.filter(row => row.record?._id?.toString() !== data.id));
      if (wasInList) setMobileResponseData(m => m ? { ...m, totalCount: Math.max(0, (m.totalCount || 0) - 1) } : m);
    }
    return;
  }
  // type: 'init' — skip if a modal is open (avoid disrupting user mid-edit)
  if (modalVisibleRef.current) return;
  initReceivedRef.current = true;
  setMobileResponseData(data?.response);
}, []);

// ─── Register listener once, re-subscribe on reconnect ────────────────────
useEffect(() => {
  socket.on('mobileService', handleMobileService);
  const onReconnect = () => setSubscribeKey(k => k + 1);
  socket.on('connect', onReconnect);
  return () => {
    socket.off('mobileService', handleMobileService);
    socket.off('connect', onReconnect);
  };
}, [handleMobileService]);

// ─── Emit subscribe whenever filters/params change or socket reconnects ───
useEffect(() => {
  if (!authenticatedUserDetail?._id) return;
  initReceivedRef.current = false;
  // Clear stale records immediately so no wrong-tab data shows during loading
  setDataSource([]);
  setMobileResponseData(undefined);
  setLoading(true);
  socket.emit('subscribe', {
    action: 'subscribe',
    module: 'mobileService',
    param: {
      filters: {
        ...filters,
        startDate: currentViewStatus=="due"? null :startDate ?? null,
        endDate: currentViewStatus=="due"? null : endDate ?? null,
        siteId: site?._id ?? null,
        status: currentViewStatus,
      },
      pageSize,
      page,
      search,
      userId: authenticatedUserDetail?._id,
      tenantId: authenticatedUserDetail?.tenantId,
      customBranch: authenticatedUserDetail?.permission?.Branch?.customBranch?.map(b => b.id) ?? null,
    },
  });
}, [subscribeKey, search, page, pageSize, startDate, endDate, site?._id, currentViewStatus, filters, authenticatedUserDetail?._id]);
  

  useEffect(()=>{
    if(search?.length>0){
      setPageSize(20);
      setPage(1);
    }else{
      setPageSize(20);
      setPage(1);

    }
  },[search]);



  const [activeKey, setActiveKey] = useState("overview");
  const [transferModal, setKeyTransferModal] = useState(null);

  const [logDrawer, setLogDrawer] = useState(false);
  const openLogs = () => setLogDrawer(true);

  // Modal handlers
  const showModal = (record) => {
    setSelectedTask(record);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedTask(null);
  };

  const [newETAResponseId, setNewETAResponseId] = useState(null);

  const handelNewETA = (id) => {
    setNewETAModalVisible(true);
    setNewETAResponseId(id);
  };

  function measureText(text, font = '14px Inter') {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    return ctx.measureText(text).width;
  }

  const PADDING = 32;
  const TAG_PADDING = 48;

  const getMaxWidth = (values, font) =>
    Math.max(...values.map(v => measureText(v, font))) + PADDING;

  const [dataSource, setDataSource] = useState([]);
  useEffect(() => { dataSourceRef.current = dataSource; }, [dataSource]);

  const weekdays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

  const getScheduleBoxes = (scheduleDays = []) => {
    return weekdays.map(day => ({
      day,
      filled: scheduleDays?.includes(day),
    }));
  };
  

  // Ascending sort for active services, descending for completed
  const sortByStartTime = (rows, desc = false) =>
    [...rows].sort((a, b) => {
      const aT = dayjs(a.startTime).isValid() ? dayjs(a.startTime).valueOf() : 0;
      const bT = dayjs(b.startTime).isValid() ? dayjs(b.startTime).valueOf() : 0;
      return desc ? bT - aT : aT - bT;
    });

  const toRow = (res, index) => ({
    key: index,
    jobType: res?.dutyDetail?.name,
    site: res?.siteDetail?.sitename,
    customer: res?.customerDetail?.customername,
    siteDetail: res?.siteDetail?.postcode,
    priority: res?.priority,
    status: res?.status || "onschedule",
    startTime: res?.startTime,
    endTime: res?.endTime,
    reportSubmittedAt: res?.reportSubmittedAt || null,
    submittedVia: res?.submittedVia === "WFC App" ? "WFC App" : "Manually",
    reportSharedAt: res?.reportSharedAt || null,
    reportSharedTo: res?.reportSharedTo || null,
    startAt: res?.startAt || null,
    finishAt: res?.finishAt || null,
    cords: res?.cords || null,
    assignee: res?.employeeDetail
      ? res?.employeeDetail?.firstname + " " + (res?.employeeDetail?.lastname || "")
      : res?.supplierDetail
      ? res?.supplierDetail?.suppliername
      : "---",
    record: res,
    scheduleType: res?.scheduleType === "one-off" ? "One-Off" : "Scheduled",
    scheduleBoxes: res?.frequencyDays? [] : getScheduleBoxes(res?.scheduleDays),
  });

  useEffect(()=>{
    if(mobileResponseData?.mobileResponse){
      const isCompleted = currentViewStatus?.toLowerCase() === "completed";
      const mapped = mobileResponseData.mobileResponse.map((res, index) => toRow(res, index));
      setDataSource(sortByStartTime(mapped, isCompleted));
    }
  },[mobileResponseData?.mobileResponse, currentViewStatus]);

  // Hide spinner only after: server responded (initReceivedRef) AND dataSource
  // has been painted — double-rAF ensures no visible gap before data appears.
  useEffect(() => {
    if (!initReceivedRef.current) return;
    initReceivedRef.current = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setLoading(false);
      });
    });
  }, [dataSource]);

  // Filter handlers
  const handleApplyFilters = () => {
    const values = form.getFieldsValue();
    setDrawerVisible(false);
  };

  const handleClearFilters = () => {
    form.resetFields();
    setDateRange(null);
  };


  const getActiveFilterCount = () => {
    return Object.values(filters).reduce((acc, curr) => acc + (curr?.length || 0), 0);
  };

  const navigate = useNavigate();

  const [cancelTaskModal, setCancelTaskModal] = useState({ modal: false, taskId: null, templateId: null });

  const handleCancelTask = (_id, templateId) => {
    setCancelTaskModal({ modal: true, taskId: _id, templateId: templateId || null });
  };

  function getOrdinal(n) {
    if (!n) return n;
  
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  const columns = [
    {
      title: 'Site',
      dataIndex: 'site',
      key: 'site',
      width: 240,
      render: (text, record) => (
        <div onClick={()=>navigate("/user/site-detail/"+record?.record?.siteDetail?._id)}>
          <div style={{ fontWeight: 500, wordBreak: 'break-word' }} className="link">{text}</div>
          <div style={{ fontSize: 13, color: '#9ca3af', wordBreak: 'break-word' }}>
            {record.siteDetail}
          </div>
        </div>
      ),
    },

    {
      title: 'Customer',
      dataIndex: 'jobType',
      key: 'jobType',
      width:250,
      render: (text, record) => {
        return(
        <div
          style={{
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'color 0.2s ease',
            display:'flex',
            alignItems:'center',
            gap:'10px'
          }}
          
        >

          <div style={{ fontWeight: 500, width:'70%' }} 
            onClick={() => showModal(record?.record)}
            // onMouseEnter={(e) => e.target.style.color = '#00bda5'}
            // onMouseLeave={(e) => e.target.style.color = '#1f2937'}
          >

            <div style={{ wordBreak: 'break-word', color:'black' }} onClick={()=>navigate("/user/customer-detail/"+record?.record?.customerDetail?._id)}>
                {record?.customer}

            </div>

            <div style={{ fontSize: 13, color: '#9ca3af', wordBreak: 'break-word' }} className="link">{text} </div>

          </div>
          
          <div style={{fontSize: 10, color: '#9ca3af', display:'flex', flexDirection:'row', width:'30%', alignItems:'center', gap:'10%'}}>
            
            <Popover
              content={record?.record?.customerDetail?.metadata?.mobileno || "no number found"}
            >
              <FontAwesomeIcon icon={faPhone}/>
            </Popover>

            <Popover
              content={
                record?.record?.customerDetail?.metadata?.customeremail || "no email found"
              }
            >
              <FontAwesomeIcon icon={faEnvelope}/>
            </Popover>
          </div>

        </div>
      )},
    },
    {
      title: 'Assignee',
      dataIndex: 'assignee',
      key: 'assignee',
      width:250,

      // width: getMaxWidth(dataSource.map(d => d.assignee)),
      render: (text, record) => (
        <div 
          style={{  display:'flex', alignItems:'center', gap:'10px' }} 
        >

            <div  style={{ wordBreak: 'break-word',  width:'70%' }}
              onClick={()=>{
                record?.record?.status=="Open"? null
                :
                record?.record?.employeeDetail?
                navigate("/user/employee-detail/"+record?.record?.employeeDetail?._id)
                :
                navigate("/user/agency-detail/"+record?.record?.supplierDetail?._id)
      
              }}
            >
              
              <div style={{ fontWeight: 500,wordBreak: 'break-word'  }} className="link">{text} </div>
              <div style={{ fontSize: 13, color: '#9ca3af' }}>
                {
                
                  record?.record?.status=="Open"? "In-House" : record?.record?.employeeDetail? "Employee" : "Supplier"
                }

              </div>
              {/* how the job reached its officer, so "why did he get this?" answers itself */}
              {(() => {
                const shared = record?.record?.shared;
                const via = record?.record?.status=="Open"
                  ? (shared?.at && !shared?.closedAt ? "shared" : "open")
                  : record?.record?.assignedVia;
                const label = { keyHolder: "Auto · holds keys", clockIn: "Auto · at Clock In", callout: "Callout by officer", control: "Picked by control", open: "Open · waiting for control", shared: "Shared · waiting for a driver", sharedCallout: "Shared callout · accepted" }[via];
                const why = {
                  keyHolder: "Nobody was picked, so it went to the officer holding this site's keys who is working now",
                  clockIn: "Given to him when he clocked in with this site's key group",
                  callout: "He took the call and started this job himself in the app",
                  control: "Control chose who does it",
                  open: "Nobody holding this site's keys is working, or the company sends jobs by hand",
                  shared: `${shared?.byName || "An officer"} took the call and shared it. Every direct-jobs driver is offered it every 2 minutes until one accepts${shared?.declinedBy?.length ? ` (${shared.declinedBy.length} can't)` : ""}. You can still assign it.`,
                  sharedCallout: `Shared by ${shared?.byName || "an officer"}${shared?.acceptedAt && shared?.at ? `, accepted after ${Math.max(0, Math.round((new Date(shared.acceptedAt) - new Date(shared.at)) / 60000))} min` : ""}`,
                }[via];
                return label ? <span className={`mo-via mo-via-${via}`} title={why}>{label}</span> : null;
              })()}
            </div>


            <div style={{fontSize: 10, color: '#9ca3af', display:'flex', flexDirection:'row', width:'30%', alignItems:'center', gap:'10%'}}>

              {(record?.record?.employeeDetail?.metadata?.imageURL || record?.record?.supplierDetail?.metadata?.imageURL) && (
                <img
                  src={record?.record?.employeeDetail?.metadata?.imageURL || record?.record?.supplierDetail?.metadata?.imageURL}
                  alt=""
                  style={{width:20, height:20, borderRadius:'50%', objectFit:'cover', flexShrink:0}}
                />
              )}

              <Popover
                content={record?.record?.supplierDetail?.metadata?.controlcontactno || record?.record?.employeeDetail?.metadata?.mobileno}>
                <FontAwesomeIcon icon={faPhone} style={{cursor:'pointer'}} 
                  title={
                    (record?.record?.supplierDetail?.metadata?.controlcontactno ||
                    record?.record?.employeeDetail?.metadata?.mobileno ) || "no number found"
                  }
                />
              </Popover>

              <a

                href={
                  (record?.record?.supplierDetail?.metadata?.controlcontactno || 
                    record?.record?.employeeDetail?.metadata?.mobileno)?
                  `https://wa.me/${
                  (record?.record?.supplierDetail?.metadata?.controlcontactno || 
                  record?.record?.employeeDetail?.metadata?.mobileno)
                    ?.toString()
                    .replaceAll(/\D/g, "")
                }` : ""}
                target="_blank"
                rel="noreferrer"
              >

                <WhatsAppOutlined style={{fontSize:12}}/>
              </a>

              <Popover
                content={
                    
                  (record?.record?.supplierDetail?.metadata?.controlemail ||
                  record?.record?.employeeDetail?.metadata?.email) || "no email found"
                  
                }
              >
                <FontAwesomeIcon icon={faEnvelope} 
                  title={
                    record?.record?.supplierDetail?.metadata?.controlemail ||
                    record?.record?.employeeDetail?.metadata?.email 
                  }
                />
              </Popover>
              
            </div>


        </div>

      ),
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      key: 'priority',
      width:
        90,
      render: priority => {
        const colors = {
          high: { bg: '#FF4D4F', text: '#9a3412' },
          medium: { bg: '#FA8C16', text: '#92400e' },
          low: { bg: '#52C41A', text: '#065f46' },
        };
        const color = colors[priority?.toLowerCase()];
        return (
          <div
            style={{
              // backgroundColor: color?.bg,
              // color: '#FFFFFF',
              // border: 'none',
              // borderRadius: 6,
              // padding: '4px 12px',
              // fontWeight: 500,
              // whiteSpace: 'nowrap',
            }}
          >
            {priority[0]?.toUpperCase()+priority.slice(1, priority.length)}
          </div>
        );
      }
    },
    // Only meaningful once a report exists — shown on the Completed Services tab only.
    ...(currentViewStatus === "completed" ? [{
      title: 'Submitted Via',
      dataIndex: 'submittedVia',
      key: 'submittedVia',
      width: 190,
      render: (submittedVia, record) => {
        // Same "lat,lng" string coords[0] (start) / coords[1] (finish) — dedupe when identical.
        const coords = [...new Set((record?.cords || []).filter(Boolean))];
        const hasDateRange = submittedVia === "WFC App" && record?.startAt && record?.finishAt;
        return (
          <div>
            <Tag
              style={{
                backgroundColor: submittedVia === "WFC App" ? '#d1fae5' : '#f3f4f6',
                color: submittedVia === "WFC App" ? '#065f46' : '#374151',
                border: `1px solid ${submittedVia === "WFC App" ? '#d1fae5' : '#e5e7eb'}`,
                borderRadius: 6,
                fontWeight: 500,
              }}
            >
              {submittedVia}
            </Tag>
            {
              hasDateRange &&
              <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 4 }}>
                {dayjs(record.startAt).format("DD/MM/YYYY HH:mm")} - {dayjs(record.finishAt).format("HH:mm")}
              </div>
            }
            {
              // Submitted via the app but no start/finish timestamps captured live —
              // the record was still filled in completely by hand.
              submittedVia === "WFC App" && !hasDateRange &&
              <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 4 }}>
                Completed Manually
              </div>
            }
            {
              // the report was emailed to the customer (wfc-server scheduleReport.service
              // sendReportEmail) - who to and when on hover
              record?.reportSharedAt &&
              <Tooltip
                title={
                  <div>
                    <div>Report emailed to {(record.reportSharedTo || []).join(', ') || 'the customer'}</div>
                    <div style={{ opacity: .8 }}>{dayjs(record.reportSharedAt).format("DD/MM/YYYY HH:mm")}</div>
                  </div>
                }
              >
                <div style={{ fontSize: 12, marginTop: 4, color: '#0f766e', display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'default' }}>
                  <FontAwesomeIcon icon={faEnvelope} /> Emailed to customer
                </div>
              </Tooltip>
            }
            {
              submittedVia === "WFC App" && coords?.length > 0 &&
              <div style={{ fontSize: 12, marginTop: 2 }}>
                <a
                  onClick={(e) => { e.stopPropagation(); setRouteModalCoords(coords); }}
                  style={{ color: '#0091ae', cursor: 'pointer' }}
                >
                  See Route
                </a>
              </div>
            }
          </div>
        );
      },
    }] : []),
    {
      title: 'Schedule Type',
      dataIndex: 'scheduleType',
      key: 'scheduleType',
      minWidth: 150,
      render:(scheduleType, record)=>{
       
        return(
          <span>
            <div>{scheduleType}</div>

            <div style={{display:'flex', flexDirection:'row'}}>
              
              {
              record?.scheduleBoxes?.length>0 && scheduleType=="Scheduled"?
                record?.scheduleBoxes.map((box, index) => (
                      <div style={{textAlign:'center'}}>
                       
                        <div
                          key={box.day}
                          style={{
                            width: "20px",
                            height: "20px",
                            border: "1px solid #81b06f",
                            backgroundColor: box.filled ? "#81b06f" : "#fff",
                            color: box.filled ?'white' : 'black',
                            marginRight: '2px',
                            borderRadius: '4px',
                            fontSize:'12px'
                            
                          }}
                        >
                          {weekdays[index][0]?.toUpperCase()}
                        </div>
                      </div>
                ))
                :scheduleType=="Scheduled"?
                <div style={{ fontWeight:'bold'}}>
                  Every {getOrdinal(record?.record?.frequencyDays)} day
                </div>
                :
                null
              }
            </div>


          </span>
        );
      }
    },
    {
      title: 'Status & Time',
      dataIndex: 'status',
      key: 'status',
      width:
        Math.max(...dataSource.map(d => measureText(d.status))) +
        TAG_PADDING,
      render: (status, record) => {
        const isCancelled = record?.record?.status?.toLowerCase()=="cancel";
        const isInReview = record?.record?.status?.toLowerCase()=="in-review";
        const colors = {
          cancel: {
            // bg: '#f87171',
            // text: '#ffffff'
            bg: '#E5E7EB',
            color: '#374151',
            border: '#E5E7EB'
          },
          onschedule: {
            // bg: '#e0e7ff',
            // text: '#3730a3'
            bg: 'white',
            text: '#677b8b',
            border: '#cbd6e2'
          },
          overdue: {
            // bg: '#fee2e2',
            // text: '#991b1b'
            bg: 'rgb(244, 67, 54, 0.8)',
            text: 'white',
            border: 'rgb(244, 67, 54, 0.8)'
          },
          due: {
            // bg: '#fef3c7',
            // text: '#92400e'
            bg: 'rgba(255, 140, 0, 0.8)',
            border: 'rgba(255, 140, 0, 0.8)',
            text: 'white'
          },
          "in-review": {
            bg: '#cffafe',
            text: '#155e75'
          },
          completed: {
            bg: '#d1fae5',
            text: '#065f46',
            border: '#d1fae5'
          },
        };
        
        const color = colors[status?.toLowerCase()] || { bg: '#f3f4f6', text: '#374151' };
        
        return (
          <span style={reportLoadingId==record?.record?._id ?{opacity:0.4}: {opacity: 1}}>
            <Tag
              style={{
                backgroundColor: color.bg,
                color: color.text,
                border: `1px solid ${color.border}`,
                borderRadius: 6,
                padding: '4px 12px',
                fontWeight: 500,
                whiteSpace: 'nowrap',
                flexDirection:'row',
                display:'flex',
                justifyContent:'space-between',
                // width: 'max-content'
              }}
            >
              <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}}>

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  {
                    status=="onschedule"?
                    "ON-SCHEDULE" :
                    status?.toUpperCase()
                  } 

                  {
                    record?.record?.eta &&
                    <>
                      {/* <span>ETA</span> */}
                      <span style={{color:'black'}}> - ETA : {record?.record?.eta[record?.record?.eta.length - 1]?.eta} </span>

                    </>
                  }


                </div>

                <span>
                  {record.startTime && record.endTime && (
                    <div style={{ fontSize: 12, color: color.text, fontWeight:'bold' }}>
                      {`${dayjs(record.startTime)?.format("DD/MM/YYYY HH:mm")} - ${dayjs(record.endTime)?.format("DD/MM/YYYY HH:mm")}`}
                    </div>
                  )}
                  
                </span>

              </div>

              <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between', width:'10%'}}>

                
                <span title="Recursive Task" className="cursor">
                  {}
                </span>

                <div >
                  
                  <Dropdown overlay={
                      <Menu>
                          {
                            isInReview?
                            <>
                              <Menu.Item className="popoverdataitem" onClick={()=>{ setActiveKey("response"); showModal(record?.record);}}>
                                <FontAwesomeIcon icon={faFileAlt} style={{marginRight: 8}} />Review Report
                              </Menu.Item>

                              <Menu.Item className="popoverdataitem" onClick={()=>{ setActiveKey("activity"); showModal(record?.record);}}>
                                <FontAwesomeIcon icon={faClipboardList} style={{marginRight: 8}} />Activity Logs
                              </Menu.Item>

                              <div className="divider"></div>

                              {
                                    record?.record?.status?.toLowerCase()=="cancel"?
                                    <Menu.Item disabled>
                                      <FontAwesomeIcon icon={faBan} style={{marginRight: 8}} />Already Cancelled
                                    </Menu.Item>
                                    :
                                    <Menu.Item style={{color:'red'}} className="popoverdataitem" onClick={()=>{ handleCancelTask(record?.record?._id, record?.record?.templateId) }}>
                                      <FontAwesomeIcon icon={faBan} style={{marginRight: 8}} />Cancel Service Task
                                    </Menu.Item>
                              }
                            </>
                            :
                            record?.record?.status=="completed"?
                            <>
                              <Menu.Item className="popoverdataitem" onClick={() => {setActiveKey("response"); showModal(record?.record); }}>
                                <FontAwesomeIcon icon={faEye} style={{marginRight: 8}} />View Report
                              </Menu.Item>

                              <Menu.Item disabled={reportLoading} className="popoverdataitem" onClick={()=>{ downloadPdfFromUrl(record?.record?._id, record?.record?.reportTemplateId, record) }}>
                                <FontAwesomeIcon icon={faDownload} style={{marginRight: 8}} />Download Report {reportLoading ? <Spinner/> : ""}
                              </Menu.Item>
                            </>
                            :
                            <>
                                {
                                  isCancelled ? null
                                  :
                                  <>
                                    <Menu.Item className="popoverdataitem" onClick={()=>{ handelNewETA(record?.record?._id);}}>
                                      <FontAwesomeIcon icon={faClock} style={{marginRight: 8}} />Update ETA
                                    </Menu.Item>

                                    <Menu.Item className="popoverdataitem" onClick={()=>{ setActiveKey("response"); showModal(record?.record);}}>
                                      <FontAwesomeIcon icon={faFileAlt} style={{marginRight: 8}} />Update Report
                                    </Menu.Item>
                                  </>
                                }

                                <Menu.Item className="popoverdataitem" onClick={()=>{ setActiveKey("edit"); showModal(record?.record);}}>
                                  <FontAwesomeIcon icon={faEdit} style={{marginRight: 8}} />Edit Task
                                </Menu.Item>

                                <Menu.Item className="popoverdataitem" onClick={()=>{ setKeyTransferModal(record?.record);}}>
                                  <FontAwesomeIcon icon={faRightLeft} style={{marginRight: 8}} />Transfer Task
                                </Menu.Item>

                                <Menu.Item className="popoverdataitem" onClick={()=>{ setActiveKey("activity"); showModal(record?.record);}}>
                                  <FontAwesomeIcon icon={faClipboardList} style={{marginRight: 8}} />Activity Logs
                                </Menu.Item>


                                <div className="divider"></div>


                              {
                                record?.record?.status?.toLowerCase()=="cancel"?
                                <Menu.Item disabled>
                                  <FontAwesomeIcon icon={faBan} style={{marginRight: 8}} />Already Cancelled
                                </Menu.Item>
                                :
                                <Menu.Item style={{color:'red'}} className="popoverdataitem" onClick={()=>{ handleCancelTask(record?.record?._id, record?.record?.templateId) }}>
                                  <FontAwesomeIcon icon={faBan} style={{marginRight: 8}} />Cancel Service Task
                                </Menu.Item>
                              }

                            </>
                          }
                          

                      </Menu>
                  
                  } trigger={"click"}>

                    <div className="ico-bound"  onClick={(e)=>{ }}> 
                      {
                        reportLoadingId==record?.record?._id? <Spinner />
                        :
                        <FontAwesomeIcon style={{
                          fontSize: '12px',
                          color: status === 'cancel' ? 'undefined' : undefined
                        }} icon={faEllipsisVertical} /> 
                      }
                    </div> 

                  </Dropdown>   
                  
                </div>
              </div>

            </Tag>
          </span>
        );
      },
      sorter: (a, b) => {
        // convert startTime to dayjs objects for comparison
        const startA = dayjs(a.startTime);
        const startB = dayjs(b.startTime);
    
        return startA.isBefore(startB) ? -1 : startA.isAfter(startB) ? 1 : 0;
      },
      sortDirections: ['descend', 'ascend'], // default sorting directions
    },
  ];

  // A submitted report (in review) that wfc-server's AI read flagged as needing attention -
  // the row gets a red border. reportAssessment rides along on the record from realtime.
  const needsAttention = (row) =>
    row?.record?.status?.toLowerCase() === "in-review" && row?.record?.reportAssessment?.needsAttention === true;

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
    },
  };



  // In MobileResponseServices component, add this state and effect:
  const [stableSelectedTask, setStableSelectedTask] = useState(null);

  // Stabilize selectedTask to only update when the ID actually changes
  useEffect(() => {
    if (!selectedTask) {
      setStableSelectedTask(null);
      return;
    }
    
    // Only update if it's a different task (different ID)
    if (!stableSelectedTask || stableSelectedTask._id !== selectedTask._id) {
      setStableSelectedTask(selectedTask);
    }
  }, [selectedTask]);


  const [reportLoading, setReportLoading] = useState(false);
  const [reportLoadingId, setReportLoadingId] = useState(null);
  const downloadPdfFromUrl = async (jobId, templateId, record) => {
   
    // Safely add jobId to loading array
    // setDownloadingSpecificJobReport(prev => {
    //     if (!prev.includes(jobId)) return [...prev, jobId];
    //     return prev; // already in progress
    // });
    setReportLoading(true);
    setReportLoadingId(jobId);

    try{
        // drawn by wfc-server - the generic layout, or the client's own (Ward / RelyOn / PSG)
        await downloadReportPdf({ jobId, templateId: record?.record?.reportTemplateId || templateId, filename: 'report' });
        message.success("Report downloaded successfully");
    }
    catch(err){
        message.error(err?.message || "Failed to download report.");

    }finally{
        // Safely remove jobId after completion
        // setDownloadingSpecificJobReport(prev => prev.filter(id => id !== jobId));
      setReportLoading(false);
      setReportLoadingId(null);

    }

  };

  // ─── Export (Completed Services tab only) ──────────────────────────────
  // Site, Duty Type and Shift Start/End already live on the mobile service
  // record; report submission time comes from scheduleReportDetail.createdAt
  // (joined server-side onto the record by jobId).
  // Export always asks the server for every record matching the current
  // filters/search/month — it does NOT read from the on-screen `dataSource`,
  // which only ever holds the current page of the live socket subscription.
  const [fetchMobileResponseForExport] = useLazyQuery(getMobileResponseQuery, {
    fetchPolicy: 'network-only',
  });
  const [exportLoading, setExportLoading] = useState(false);

  const fetchAllCompletedRows = async () => {
    const { data } = await fetchMobileResponseForExport({
      variables: {
        input: {
          filters: {
            ...filters,
            startDate: startDate ?? null,
            endDate: endDate ?? null,
            status: 'completed',
          },
          search,
          page: 1,
          pageSize: 100000,
        },
      },
    });
    const records = data?.getMobileResponse?.response?.mobileResponse || [];
    return records.map((res, index) => toRow(res, index));
  };

  const buildExportRows = (rows) =>
    rows.map((row) => ({
      "Site": row?.site || "---",
      "Duty Type": row?.jobType || "---",
      "Shift Start": row?.startTime ? dayjs(row.startTime).format("DD/MM/YYYY HH:mm") : "---",
      "Shift End": row?.endTime ? dayjs(row.endTime).format("DD/MM/YYYY HH:mm") : "---",
      "Report Submitted At": row?.reportSubmittedAt ? dayjs(row.reportSubmittedAt).format("DD/MM/YYYY HH:mm") : "---",
      "Submitted Via": row?.submittedVia || "---",
    }));

  const exportToCSV = async () => {
    setExportLoading(true);
    try {
      const rows = await fetchAllCompletedRows();
      if (rows?.length === 0) {
        message.warning("There is nothing to export");
        return;
      }
      const csv = Papa.unparse(buildExportRows(rows));
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, `Completed Mobile Services - ${dayjs().format("DD-MM-YYYY")}.csv`);
    } catch (err) {
      message.error("Failed to export CSV");
    } finally {
      setExportLoading(false);
    }
  };

  const exportToPdf = async () => {
    setExportLoading(true);
    try {
      const rows = buildExportRows(await fetchAllCompletedRows());
      if (rows?.length === 0) {
        message.warning("There is nothing to export");
        return;
      }
      const doc = new jsPDF({ orientation: "landscape" });
      doc.setFontSize(14);
      doc.text("Completed Mobile Services", 14, 15);
      doc.setFontSize(10);
      doc.text(`Run Date: ${dayjs().format("DD/MM/YYYY HH:mm")}`, 14, 21);
      doc.autoTable({
        startY: 26,
        head: [Object.keys(rows[0])],
        body: rows.map((row) => Object.values(row)),
        styles: { fontSize: 9 },
        headStyles: { fillColor: [13, 92, 99] },
      });
      doc.save(`Completed Mobile Services - ${dayjs().format("DD-MM-YYYY")}.pdf`);
    } catch (err) {
      message.error("Failed to export PDF");
    } finally {
      setExportLoading(false);
    }
  };

  const exportMenu = (
    <Menu>
      <Menu.Item key="csv" disabled={exportLoading} onClick={exportToCSV}>Export CSV</Menu.Item>
      <Menu.Item key="pdf" disabled={exportLoading} onClick={exportToPdf}>Export PDF</Menu.Item>
    </Menu>
  );


  return (
    <div style={{
      padding: '25px 48px',
    }}>

        <div 
          style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'flex-start',
            marginBottom: '5px',
          }}
        >

          <FloatingHelp slugs={["ops-mobile-services", "setup-supplier-app", "finance-calculating-pay-bill"]} />
          <div className='grid-title'>
            Mobile Services
              <span className='grid-subtitle'>
                  {" - "+mobileResponseData?.totalCount } records  &emsp;
                  
              </span>
          </div>


          <Space size={12}>
            {/* <Button
              onClick={openLogs}
              style={{ height: 38, borderRadius: 8, border: '2px solid #e5e7eb', fontWeight: 500 }}
            >
              Generation Logs
            </Button> */}
            {
              currentViewStatus === "completed" &&
              <Dropdown overlay={exportMenu} trigger={["click"]} disabled={exportLoading}>
                <Button
                  disabled={exportLoading}
                  style={{ height: 38, borderRadius: 8, border: '2px solid #e5e7eb', fontWeight: 500 }}
                >
                  {
                    exportLoading?
                    <Spinner/>
                    :
                    <>
                      <FontAwesomeIcon icon={faDownload} style={{marginRight: 8}} />
                      Export <CaretDownFilled />
                    </>
                  }
                </Button>
              </Dropdown>
            }
            <Button
              type="primary"
              onClick={()=>setNewResponseModal(true)}
              className="grid-filed-btn"
            >
              New Service Task
            </Button>
          </Space>

        </div>

        <div
          className='setting-body-inner grid-tabs' style={{
            padding: '10px 0px', 
            // display: 'flex', alignItems:'center'
          }}
        >
          <Tabs
            items={[
              {
                key: 'all',
                label: 'All Active Services',
              },

              // {
              //   key: 'onschedule',
              //   label: 'On-Schedule Services',
              // },

              {
                key: 'due',
                label: 'Due & Overdue Services',
              },


              // {
              //   key: 'inprogress',
              //   label: 'In-Progress Services',
              // },


              {
                key: 'completed',
                label: 'Completed Services',
              },



              // {
              //   key: 'overdue',
              //   label: 'OverDue Services',
              // },

              {
                key: 'cancel',
                label: 'Cancelled Services',
              }

            ]}
            onChange={setCurrentViewStatus}
          />

        </div>

        {/* Enhanced Search & Filter Container */}
        
          <div style={{ 
            display: 'flex',
            marginBottom: '14px',
            marginTop:'-16px',
            justifyContent:'space-between'
          }}>

            <Input
              placeholder="Search by Customer, Site, Postcode, Assignee..."
              onChange={(e) => debouncedSearch(e.target.value)}
              suffix={<FontAwesomeIcon icon={faSearch} style={{color:'#0091ae'}}/>}

              className="generic-input-control"
              style={{
                width:'min(500px, 100%)', maxWidth:'500px',
                height: '40px',
                borderRadius: '14px',
                border: '2px solid #e5e7eb',
                transition: 'all 0.3s ease'
              }}
              allowClear
              onFocus={(e) => {
                e.target.style.borderColor = '#00bda5';
                e.target.style.boxShadow = '0 0 0 4px rgba(0, 189, 165, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e5e7eb';
                e.target.style.boxShadow = 'none';
              }}
            />

            {
              currentViewStatus!=="due"?
                <div style={{display:'flex', justifyContent:'center', gap:'16px', alignItems:'center'}}>

                  <div style={{display:'flex', gap:'15px', alignItems:'center', paddingRight:'1px'}}>
                    <div style={{display:'flex', gap:'5px', alignItems:'center'}}>
                      <span className="sicon-bound" onClick={previousMonth}><FontAwesomeIcon icon={faCaretLeft} style={{fontSize:'16px'}} /></span>
                      <div style={{display:'inline-block', position:'relative', height:'40px'}}>
                        <Input
                          style={{width:'100%', textAlign:'center', padding:'4px 20px', height:'40px', borderRadius:'14px'}}
                          value={dateRange?.length>0 ? dayjs(dateRange[0]).format('MMM YYYY') : null}
                          readOnly

                        />
                        <div style={{position:'absolute', top:'0', width:'100%', zIndex:'1', opacity:'0'}}>
                          <DatePicker picker="month" disabledDate={disabledDate} className="generic-input-control" onChange={handelDateChange} />
                        </div>
                      </div>
                      <span className="sicon-bound" onClick={nextMonth}><FontAwesomeIcon style={{fontSize:'16px'}} icon={faCaretRight} /></span>
                    </div>

                    <Button className="sm-btn" style={{height:'40px', width:'100px'}} onClick={()=>{
                      const { start, end, dates } = utcMonthRange(dayjs());
                      if(startDate?.isSame(start) && endDate?.isSame(end)) return;
                      setStartDate(start);
                      setEndDate(end);
                      setDateRange(dates);
                    }}>This Month</Button>

                  </div>

                  <Badge count={getActiveFilterCount()} offset={[-5, 5]}>
                    <Button
                      icon={<FilterOutlined />}
                      onClick={() => setDrawerVisible(true)}
                      style={{
                        height: '40px',
                        borderRadius: '14px',
                        border: '2px solid #e5e7eb',
                        color: '#374151',
                        fontWeight: 500,
                        padding: '0 24px',
                        background: getActiveFilterCount() > 0 ? '#f0fdf4' : '#ffffff',
                        transition: 'all 0.3s ease',
                        marginTop:'3px'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.borderColor = '#00bda5';
                        e.target.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.borderColor = '#e5e7eb';
                        e.target.style.transform = 'translateY(0)';
                      }}
                    >
                      Filters 
                    </Button>
                  </Badge>

                </div>
              :null
            }

              

          {/* Quick Filters */}
          {/* <div style={{ 
            display: 'flex', 
            gap: '12px',
            paddingTop: '16px',
            borderTop: '1px solid #f3f4f6',
            alignItems: 'center',
            flexWrap: 'wrap'
          }}>
            <span style={{ 
              fontSize: '14px', 
              fontWeight: 500, 
              color: '#6b7280',
              marginRight: '4px'
            }}>
              Quick filters:
            </span>
            {['High Priority', 'Today', 'onschedule', 'Unonschedule'].map(filter => (
              <Button
                key={filter}
                size="small"
                type={quickFilter === filter ? 'primary' : 'default'}
                onClick={() => setQuickFilter(quickFilter === filter ? null : filter)}
                style={{
                  borderRadius: '8px',
                  fontWeight: 500,
                  border: quickFilter === filter ? 'none' : '2px solid #e5e7eb',
                  background: quickFilter === filter ? '#00bda5' : '#ffffff',
                  color: quickFilter === filter ? '#ffffff' : '#6b7280',
                  transition: 'all 0.3s ease',
                  padding: '4px 16px',
                  height: '32px'
                }}
                onMouseEnter={(e) => {
                  if (quickFilter !== filter) {
                    e.target.style.borderColor = '#00bda5';
                    e.target.style.transform = 'translateY(-2px)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (quickFilter !== filter) {
                    e.target.style.borderColor = '#e5e7eb';
                    e.target.style.transform = 'translateY(0)';
                  }
                }}
              >
                {filter}
              </Button>
            ))}
          </div> */}

          {/* Active Filters Display */}
          {/* {getActiveFilterCount() > 0 && (
            <div style={{ 
              display: 'flex', 
              gap: '8px',
              paddingTop: '16px',
              borderTop: '1px solid #f3f4f6',
              marginTop: '16px',
              flexWrap: 'wrap',
              alignItems: 'center'
            }}>
              {Object.entries(filters).map(([key, values]) => 
                values?.map(value => (
                  <Tag
                    key={`${key}-${value}`}
                    closable
                    onClose={() => removeFilter(key, value)}
                    style={{
                      background: 'linear-gradient(135deg, #ecfeff 0%, #e0f2fe 100%)',
                      border: '1px solid #99f6e4',
                      borderRadius: '8px',
                      padding: '4px 12px',
                      fontSize: '13px',
                      fontWeight: 500,
                      color: '#0f766e'
                    }}
                  >
                    {key}: {value}
                  </Tag>
                ))
              )}
              <Button
                size="small"
                type="text"
                onClick={handleClearFilters}
                style={{
                  color: '#ef4444',
                  fontWeight: 500,
                  fontSize: '13px'
                }}
              >
                Clear all
              </Button>
            </div>
          )} */}
        </div>

        <div className='tableView mobileTable'>
          <Layout className='bg-white all-module-grid'>
            <Content className="site-layout">
                <Table
                  rowSelection={rowSelection}
                  columns={columns}
                  dataSource={dataSource}
                  loading={loading}
                  style={{
                    borderRadius: '8px',
                  }}
                  rowClassName={(record, index) =>
                    [index === 0 ? 'selected-row' : '', needsAttention(record) ? 'needs-attention-row' : ''].filter(Boolean).join(' ')
                  }
                  // hovering a red row says what the report flagged
                  onRow={(record) => needsAttention(record) ? { title: "Needs attention: " + (record?.record?.reportAssessment?.reason || "") } : {}}
                  className="curvedTable"
                  
                 
                  
                  sticky
                  scroll={{ x:  'max-content'
                  }}
    
                  pagination={false}
                  
                />

                <div className='table-pagination-bar'>
                  <Pagination
                    current={mobileResponseData?.currentPage}
                    pageSize={pageSize}
                    total={mobileResponseData?.totalCount}
                    showSizeChanger={true}
                    pageSizeOptions={["10", "20", "50", "100"]}
                    onChange={(page, size) => {
                      setPage(page);
                      setPageSize(size);
                    }}
                  />
              </div>

            </Content>
          </Layout>
        </div>


        <NewMobileResponseModal
          close={()=>{
            setNewResponseModal(false);
          }}
          visible={newResponseModal}
          refetch={()=>{}}
        />

        {modalVisible &&
        <EditTaskMainModal
          key={1}
          visible={modalVisible}
          onClose={()=>{closeModal();
          setActiveKey("overview")}}
          taskData={stableSelectedTask}
          activeKey={activeKey}
        />
        }

          <FilterDrawer
            drawerVisible={drawerVisible}
            setDrawerVisible={setDrawerVisible}
            handleClearFilters={handleClearFilters}
            handleApplyFilters={handleApplyFilters}
            setFilters={setFilters}
            currentViewStatus={currentViewStatus}
          />

          {
            newETAModalVisible &&
            <NewETAModal
              visible={newETAModalVisible}
              onClose={() => setNewETAModalVisible(false)}
              newETAResponseId={newETAResponseId}
              refetch={()=>{}}

            />
          }


          {
            transferModal &&
            <TransferTask
              visible={true}
              onClose={()=>setKeyTransferModal(null)}
              data={transferModal}
            />
          }

          {
            cancelTaskModal.modal &&
            <CancelTaskModal
              visible={cancelTaskModal.modal}
              templateId={cancelTaskModal.templateId}
              taskId={cancelTaskModal.taskId}
              onClose={() => setCancelTaskModal({ modal: false, taskId: null, templateId: null })}
            />
          }

          <CronGenerationLogsDrawer
            visible={logDrawer}
            onClose={() => setLogDrawer(false)}
          />

          <RouteMapModal
            visible={!!routeModalCoords}
            coords={routeModalCoords}
            onClose={() => setRouteModalCoords(null)}
            showLabels
          />

      </div>
  );
};

export default MobileResponseServices;



const FilterDrawer = ({setFilters, filters, setDrawerVisible, drawerVisible, handleClearFilters, handleApplyFilters, currentViewStatus})=>{
  const [form] = Form.useForm();


  //  pay level
  const {data: dutyTypeData, loading: dutyTypeLoading, refetchDutyType} = useQuery(getPayLevelQuery,{
      fetchPolicy: 'cache-and-network',
  });


  const [getSite, {data: siteData, loading: siteLoading,}] = useLazyQuery(getSitesQuery ,{fetchPolicy: 'cache-and-network',
    variables: {
        input: {
          filters: null
      }
    }
  });

  const debouncedSiteSearch = useMemo(
    () =>
      debounce((value) => {
        getSite({
          fetchPolicy: "cache-and-network",
          variables: {
            input: {
              filters: {
                advanceFilter: [
                  [
                    {
                      condition: "and",
                      filter: "contain_exactly",
                      filterValue: [value],
                      operator: "sitename",
                    },
                  ],
                ],
              },
            },
          },
        });
      }, 400),
    []
  );

  const handelSiteSearch = (e) => {
    debouncedSiteSearch(e);
  };


  const [getAgencyQuery, {data: agencyData, loading: agencyLoading}] = useLazyQuery(getAgencies);
 
  const handelSupplierSearch = async(input)=>{
    await getAgencyQuery(
        {fetchPolicy: 'cache-and-network',
            variables: {
                input: {
                    filters: {
                      advanceFilter: [
                        [{
                          operator: "suppliername",
                          condition: "and",
                          filter: "contain_exactly",
                          filterValue: [input]
                        }]
                      ]
                    },
                  page: 1,
                  pageSize: 5,
                }
            }
        }
    );
  };


  // Debounced version
  const debouncedSupplierSearch = useCallback(
    debounce((input) => {
        if(input?.length>2){
            handelSupplierSearch(input);
        }
    }, 500), // 500ms delay
    [] // dependencies
  );


  const [getEmployeeQuery, {data: employeeData, loading: employeeDataLoading}] = useLazyQuery(GetEmployeeRecord);

  const handelEmployeeSearch = async(input)=>{
    await getEmployeeQuery(
        {
            variables: {
                input: {
                    filters: null,
                    search: input,
                    page: 1,
                    pageSize: 5,
                }
            },
            fetchPolicy: 'cache-and-network'
        }
    );
  };


  // Debounced version
  const debouncedEmployeeSearch = useCallback(
    debounce((input) => {
        if(input?.length>2){
            handelEmployeeSearch(input);
        }
    }, 500), // 500ms delay
    [] // dependencies
  );

  const handelApply = async ()=>{
    const values = await form.validateFields();
    setFilters(values);
    setDrawerVisible(false)

  };

  useEffect(()=>{
    if(filters){
      form.setFieldsValue(filters);
    }
  },[filters]);

  return(
      <Drawer
        
        title="All filters"
        placement="right"
        className="advanceFilter"
        onClose={() => setDrawerVisible(false)}
        closeIcon={<FontAwesomeIcon icon={faClose} onClick={()=>{
          setDrawerVisible(false);
        }} className='close-icon'/>}

        open={drawerVisible}
        width={550}
        footer={
          <div className='drawer-footer'>
              <button disabled={false} className={false? 'disabled-btn drawer-filled-btn' : 'drawer-filled-btn'} onClick={handelApply}>
               {false? <Spinner color={"#ff7a53"}/> : 'Apply filter'} 
              </button>
              <button disabled={false} className='drawer-outlined-btn' onClick={()=>{
                setDrawerVisible(false);
                form.resetFields();
                setFilters({});
              }}>Clear All</button>
          </div>
        }
      >
        <Form form={form} layout="vertical">

          <Form.Item 
            label={<span style={{ fontWeight: 600, fontSize: '14px' }}>Site</span>} 
            name="site"
          >
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Select Site"
              style={{ width: '100%' }}
              suffixIcon={siteLoading?<Spinner /> :<CaretDownFilled/>}
              showSearch
              onSearch={(e)=>handelSiteSearch(e)}
              filterOption={false}
              options={siteData?.sites?.sites?.length>0?
                [...siteData?.sites?.sites?.map((site)=>(
                  {label: site?.sitename,value: site?._id}
                ))] : []
              }
            />

          </Form.Item>


          <Form.Item 
            label={<span style={{ fontWeight: 600, fontSize: '14px' }}>Priority</span>} 
            name="priority"
          >
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Select priority"
              style={{ width: '100%' }}
              suffixIcon={<CaretDownFilled/>}
              options={[
                { label: 'High', value: 'high' },
                { label: 'Medium', value: 'medium' },
                { label: 'Low', value: 'low' },
              ]}
            />

          </Form.Item>


          <Form.Item 
            label={<span style={{ fontWeight: 600, fontSize: '14px' }}>Job Type</span>} 
            name="jobType"
          >
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Select job types"
              style={{ width: '100%' }}
              suffixIcon={dutyTypeLoading? <Spinner/> : <CaretDownFilled/>}
              options={dutyTypeLoading? [] : [
                ...dutyTypeData?.getPayLevel?.response?.filter((job)=> job?.category === "mobile")?.map((job)=>({
                  label: job?.name,
                  value: job?._id
                }))  
              ]}
            />
          </Form.Item>

          {
            currentViewStatus === "completed" &&
            <Form.Item
              label={<span style={{ fontWeight: 600, fontSize: '14px' }}>Submitted Via</span>}
              name="submittedVia"
            >
              <Select
                mode="multiple"
                className="custom-select"
                placeholder="Select submission source"
                style={{ width: '100%' }}
                suffixIcon={<CaretDownFilled/>}
                options={[
                  { label: 'WFC App', value: 'WFC App' },
                  { label: 'Manually', value: 'Manually' },
                ]}
              />
            </Form.Item>
          }

          <Form.Item
            label={<span style={{ fontWeight: 600, fontSize: '14px' }}>Dispatch Method</span>}
            name="dispatchMethod"
          >
            <Select
              placeholder="Select dispatch method"
              className="custom-select"
              style={{ width: '100%' }}
              suffixIcon={<CaretDownFilled/>}
              options={[
                { label: 'In-House Mobile Officer', value: 'employee' },
                { label: 'Supplier', value: 'supplier' },
              ]}
            />
          </Form.Item>

          
          {/* Conditional Field */}
          <Form.Item
              noStyle
              shouldUpdate={(prev, curr) =>
              prev.dispatchMethod !== curr.dispatchMethod
              }
          >
          
          
          {({ getFieldValue, resetFields }) => {
            const method = getFieldValue("dispatchMethod");
            console.log(method, "method")
            if (!method) return null;

            // Reset opposite field safely
            if (method === "employee") {
                resetFields(["supplierId"]);
            } else {
                resetFields(["employeeId"]);
            }

            return (
                <Form.Item
                    name={method === "employee" ? "employeeId" : "supplierId"}
                    label={method === "employee" ? "Employee" : "Supplier"}
                    rules={[
                      {
                          required: true,
                          message:
                          method === "employee"
                              ? "Please select an employee"
                              : "Please select a supplier",
                      },
                    ]}
                >
                    <Select
                        className="custom-select"
                        showSearch
                        placeholder={
                            method === "employee"
                            ? "Select an employee..."
                            : "Select a supplier..."
                        }
                        suffixIcon={<CaretDownFilled />}
                        onSearch={method=="employee"? debouncedEmployeeSearch : debouncedSupplierSearch}
                        filterOption={false} 
                        loading={employeeDataLoading || agencyLoading}
                    >

                        {employeeDataLoading || agencyLoading?
                            <Option>
                                <div style={{display:'flex', justifyContent:'center'}}>
                                    <Spinner />
                                </div>
                            </Option>
                            :
                            method=="employee"?
                                employeeData?.getEmployee?.response?.map((emp)=>(
                                    <Option value={emp?._id}>{emp?.firstname +" "+ (emp?.lastname || "")}</Option>
                                ))

                            :
                                <>
                                {

                                  
                                    agencyData?.agencies?.agencies?.map((agency)=>(
                                        <Option value={agency?._id}>{agency?.suppliername}</Option>
                                    ))
                                }
                                </>
                        }
                    </Select>

                    
                </Form.Item>
            );
          }}

          </Form.Item>



        </Form>
      </Drawer>


  );
}